export default __webpack_public_path__ + "static/media/not_found.6a37bf03.gif";